export default "__VITE_ASSET__42c96fa7__"